import React from "react";

const baseClasses =
  "inline-flex items-center justify-center rounded-md bg-gold hover:bg-gold-dark text-navy font-semibold h-12 px-7 text-base transition-colors cursor-pointer";

export const DenefitsButton = ({ primary = false, className = "", testId = "denefits-preapproval-btn" }) => {
  if (primary) {
    return (
      <button
        data-testid={testId}
        data-denefits-button-code="prod_MhgJ30VdA6"
        data-denefits-auth_token="eadc2867895b7879e1cb35b0d29aabaf"
        onClick={() => window.createIframe && window.createIframe()}
        className={`${baseClasses} ${className}`}
      >
        Get Pre-Approved
      </button>
    );
  }
  return (
    <button
      data-testid={testId}
      onClick={() => {
        const el = document.querySelector("[data-denefits-button-code]");
        if (el) el.click();
        else if (window.createIframe) window.createIframe();
      }}
      className={`${baseClasses} ${className}`}
    >
      Get Pre-Approved
    </button>
  );
};

export default DenefitsButton;
